import React from 'react'
import { Input } from './'
import { dateService } from '../../../Services';

export const Month = props => {
    if (!props.element)
        return null;

    const customProps = Object.assign({}, { "defaultValue": "", "type": "month" }, props);
    
    if (customProps.element.min)
        customProps.element.min = dateService.getMonth(customProps.element.min);

    if (customProps.element.max)
        customProps.element.max = dateService.getMonth(customProps.element.max);

    return (<Input {...customProps} />)
}

export default Month;